import React from 'react';
import PropTypes from 'prop-types';
import './css/OrderFacts.css';
import {
  getDayText,
  getNightsTextNoRange,
  getTouristsTextActualizOrder,
  getMealText,
} from '../../Utils/CommonUtils';
import {
  PROFILE_ORDER_DEPARTURE,
  PROFILE_ORDER_NIGHTS,
  PROFILE_ORDER_TOURISTS,
  PROFILE_ORDER_MEAL,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as Calendar } from '../../images/gray-calendar-r.svg';
import { ReactComponent as Night } from '../../images/gray-night-r.svg';
import { ReactComponent as Person } from '../../images/gray-person-r.svg';
import { ReactComponent as Meal } from '../../images/meal-r.svg';

// the main tour facts of an order at a glance
function OrderFacts(props) {
  const { order } = props;

  const renderFact = (title, icon, text) =>
    text && (
      <div className="of_fact" title={title}>
        <span className="of_fact_icon">{icon}</span>
        <span className="bm_text_14">{text}</span>
      </div>
    );

  return (
    <div className="of_facts">
      {renderFact(
        PROFILE_ORDER_DEPARTURE,
        <Calendar />,
        order.departureDate && getDayText(order.departureDate),
      )}
      {renderFact(
        PROFILE_ORDER_NIGHTS,
        <Night />,
        getNightsTextNoRange(parseInt(order.nightsCount, 10)),
      )}
      {renderFact(
        PROFILE_ORDER_TOURISTS,
        <Person />,
        getTouristsTextActualizOrder(order),
      )}
      {renderFact(
        PROFILE_ORDER_MEAL,
        <Meal />,
        order.meal && getMealText(order.meal),
      )}
    </div>
  );
}

OrderFacts.propTypes = {
  order: PropTypes.instanceOf(Object).isRequired,
};

export default OrderFacts;
